<template minapp="mpx" xlang="wxml">
  <view class="es-train-information-card" wx:class="{{ isChange == 1 && 'ticket-change'}}">
    <slot></slot>
    <slot name="divider"/>
  </view>

</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  import store from '@/store'

  createComponent({
    props: {
      isChange: Number
    },
    methods: {}
  })
</script>

<style lang="stylus" scoped>
  @import '~@/mixins/stylus/color.styl'

  .es-train-information-card
    position relative
    padding 16px 12px 0px
    border-radius 8px 8px 0px 0px
    background #ffffff
    text-align left
  .ticket-change::before
    position absolute
    left 0
    top 0
    content '改签'
    width 88px
    height 32px
    color #ffffff
    // background: #FF7F41;
    background-image url('https://pt-starimg.didistatic.com/static/starimg/img/YilTfWKych1642231273019.png')
    background-size cover
    font-size 20px
    transform-origin top left
    transform scale(0.5)
    text-align center
    line-height 32px
</style>

<script name="json">
  module.exports = {
    component: true
  }
</script>